<template>
    <v-dialog :value="value" max-width="520" :persistent="loading" @input="updateDialog">
        <v-card>
            <v-card-title class="text-h6">Collega la casella qualità</v-card-title>
            <v-card-text>
                <v-alert type="info" text dense class="mb-4">
                    La password viene salvata cifrata sul backend e non resta nel browser.
                </v-alert>
                <v-text-field
                    :value="accountAddress"
                    label="Account di posta"
                    prepend-inner-icon="mdi-email-outline"
                    readonly
                    outlined
                    dense
                />
                <v-text-field
                    v-model="password"
                    label="Password della casella"
                    prepend-inner-icon="mdi-lock-outline"
                    type="password"
                    autocomplete="off"
                    outlined
                    dense
                    :disabled="loading"
                    :error-messages="errorMessage"
                    hint="Verranno verificati sia la lettura IMAP sia l’invio SMTP."
                    persistent-hint
                    @input="passwordChanged"
                    @keydown.enter.prevent="submit"
                />
            </v-card-text>
            <v-card-actions class="px-6 pb-5">
                <v-spacer />
                <v-btn text :disabled="loading" @click="close">Annulla</v-btn>
                <v-btn color="primary" :loading="loading" :disabled="!canSubmit" @click="submit">
                    Verifica e collega
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { canSubmitMailboxPassword } from "./mailSegnalazioniConfiguration.mjs";

export default {
    name: "MailSegnalazioniConfiguration",
    props: {
        value: { type: Boolean, default: false },
        accountAddress: { type: String, default: "quality@mecom.work" },
        loading: { type: Boolean, default: false },
        errorMessage: { type: String, default: "" },
    },
    data: () => ({ password: "" }),
    computed: {
        canSubmit() {
            return canSubmitMailboxPassword(this.password) && !this.loading;
        },
    },
    watch: {
        value(isOpen) {
            if (!isOpen) this.password = "";
        },
    },
    methods: {
        updateDialog(isOpen) {
            if (!isOpen && !this.loading) this.close();
        },
        close() {
            this.password = "";
            this.$emit("input", false);
        },
        passwordChanged() {
            if (this.errorMessage) this.$emit("clear-error");
        },
        submit() {
            if (!this.canSubmit) return;
            const password = this.password;
            this.password = "";
            this.$emit("save", password);
        },
    },
};
</script>
